<script lang="ts" setup>
import type { PropertyOnPage } from '@@/shared/property/api-types';

const props = withDefaults(defineProps<{
  property: PropertyOnPage
  displayPin?: boolean
}>(), {
  displayPin: false,
});

const open = defineModel<boolean>({ required: true });

const emit = defineEmits<{
  share: []
  contact: []
}>();
const location = toRef(() => props.property.location);
</script>

<template>
  <IadDialog
    v-model="open"
    modal-name="map"
  >
    <template #top-content>
      <IadTitle
        variant="x-small"
        :text="`${location.place} (${location.postcode})`"
        tag="p"
      />
    </template>
    <template #top-actions>
      <div class="flex gap-xs">
        <IadBtn
          :icon="true"
          variant="outlined"
          @click="emit('share')"
        >
          <Icon name="iad-icon:share" />
        </IadBtn>
      </div>
    </template>
    <div class="flex w-screen lg:w-[calc(100vw-4rem)] h-[calc(100vh-11rem)] lg:h-[calc(100vh-16rem)] lg:px-m">
      <IadMap
        v-if="open && location.hasMapInfo"
        class="flex-1"
        :center="[location.longitude, location.latitude]"
      >
        <IadMapControls />
        <IadMapMarker
          v-if="displayPin"
          :lgn-lat="[location.longitude, location.latitude]"
        />
        <IadMapLayerSpecification v-else>
          <IadMapLayerCircle
            :lgn-lat="[location.longitude, location.latitude]"
            :radius="location.radius"
          />
        </IadMapLayerSpecification>
      </IadMap>
    </div>
    <template #actions>
      <PropertyDialogAgentFooterActions
        v-if="property.agent"
        :agent="property.agent"
        @contact="emit('contact')"
      />
    </template>
  </IadDialog>
</template>
